/** @format */

import React, { Component } from 'react';
import { Table } from 'semantic-ui-react';

import { inject, observer } from 'mobx-react';

@inject('SalesStore')
@observer
class SaleTableTot extends Component {
  render() {
    const { SalesStore } = this.props;
    return [
      <Table.Row key="saleTable-shipping">
        <Table.Cell colSpan={3} textAlign="right">
          <small>
            <strong>Spese di Spedizione</strong>
          </small>
          <br />
        </Table.Cell>
        <Table.Cell colSpan={1}>
          <small>{SalesStore.currentSale.data.shipping.shippingCost}€</small>
          <br />
        </Table.Cell>
      </Table.Row>,
      <Table.Row key="saleTable-tot">
        <Table.Cell colSpan={3} textAlign="right">
          <small>
            <strong>Totale</strong>
          </small>
          <br />
        </Table.Cell>
        <Table.Cell colSpan={1}>
          <small>{SalesStore.currentSale.data.tot}€</small>
          <br />
        </Table.Cell>
      </Table.Row>,
    ];
  }
}

export default SaleTableTot;
